// src/utils/profileChecklist.js

// Auttaa arvojen siistimisessä (trim + null/undefined -> "")
const clean = (v) => {
  if (v == null) return "";
  if (typeof v === "string") return v.trim();
  // numerot ja booleanit kelpaa suoraan merkkijonoksi
  return String(v).trim();
};

// Yksi paikka, jossa mapataan UI:n/Backin eri nimiset kentät yhdeksi muodoksi
export function normalizeBandForChecklist(band = {}) {
  return {
    name: clean(band.name),
    slug: clean(band.slug),
    artist_type: clean(band.artist_type || band.artist_type_name),
    location: clean(band.location),
    // hyväksy kumpi tahansa kuvausavaimista
    description: clean(band.description || band.description_short),
    profile_image: clean(band.profile_image),
    // valinnainen: jos haluat käyttää myöhemmin julkaisulogiikassa
    email: clean(band.band_email || band.email),
    phone: clean(band.band_phone || band.phone),
  };
}

/**
 * Perus-checklist, jota Dashboard käyttää ohjatakseen Setup-wizardiin.
 * Pidä required vain niissä, joita oikeasti vaaditaan "perustietoihin".
 */
export function bandChecklist(band) {
  const b = normalizeBandForChecklist(band);
  const required = ["name", "slug", "artist_type", "location", "description", "profile_image"];
  const missing = required.filter((k) => !b[k]);

  return {
    ok: missing.length === 0,
    missing,       // esim. ["profile_image", "description"]
    fields: b,     // normalisoidut kentät (hyödyllinen debuggaukseen/UI:hin)
  };
}

/**
 * (Valinnainen tulevaa julkaisua varten)
 * Jos haluat vaatia lisäkenttiä ennen "Julkaise"-nappia, käytä tätä:
 */
// export function bandChecklistForPublish(band) {
//   const b = normalizeBandForChecklist(band);
//   const required = [
//     "name",
//     "slug",
//     "artist_type",
//     "location",
//     "description",
//     "profile_image",
//     // esim. myös yhteystiedot:
//     "email",
//     "phone",
//   ];
//   const missing = required.filter((k) => !b[k]);
//   return { ok: missing.length === 0, missing, fields: b };
// }
